import { ENV } from "../../config/runtimeEnv";

// CU-86d45b2z1 — one definition of the file-service display URL for the Inventory table and the customer catalogue.
export const productImageUrl = (fileId: string): string => `${ENV.VITE_FILE_SERVER}/inventory/display/${fileId}`;
